import { Dot } from "react-bootstrap-icons";
import PropTypes from "prop-types";

const RedDot = (props) => {
  return (
    <span className="position-absolute" style={{ right: props.right, top: props.top }}>
      <Dot style={{ color: "#FF6161", fontSize: "40px" }} />
    </span>
  );
};

export default RedDot;

RedDot.defaultProps = {
  right: -10,
  top: -10,
};
